import { addBoundary } from '../number';

export function animate(
  duration: number,
  callback: (progress: number) => unknown,
  onFinish?: () => unknown,
) {
  let initialTime: number | undefined = undefined;
  let suscription: number;

  function innerAnimate(current: number) {
    if (initialTime === undefined) initialTime = current;

    const ellapsed = current - initialTime;
    const progress = ellapsed / duration;

    callback(addBoundary(progress, 0, 1));
    if (progress < 1) suscription = window.requestAnimationFrame(innerAnimate);
    else onFinish?.();
  }

  suscription = window.requestAnimationFrame(innerAnimate);

  return () => {
    window.cancelAnimationFrame(suscription);
  };
}
